import React from "react";

export default function DisplayPercentage({ value }) {

  if (isNaN(value) || !isFinite(value)) {
    return <></>
  }
  return <>({value}%)</>
}